<style lang="scss" scoped>
.tile {
	text-align: center;
	cursor: pointer;
	position: relative;
	i {
		display: none;
	}
	&:hover {
		i {
			display: block !important;
		}
	}
	&__icon {
		width: 100%;
		height: auto;
		border-radius: 10px;
		background: white;
	}
	&__heading {
		margin-top: 15px;
		margin-top: 15px;
		margin-left: auto;
		margin-right: auto;
		text-overflow: ellipsis;
		text-align: center;
		width: 12ch;
		overflow: hidden;
		height: 70px;
		line-height: 23px;
	}
	.image-container {
		height: 150px;
		border-radius: 10px;
		background: white;
	}
}
</style>

<template lang="pug">
    .tile(@click='launch()')
        .image-container
            IconImage(:icon="app.Icon", :size="150").tile__icon
        h3.tile__heading {{ app.application_name || app.name }}
</template>

<script>
import tracker from "@/utils/event-tracker";
import { isUuid } from "@/utils/common";
import IconImage from "@/components/ui/IconImage";

export default {
	components: {
		IconImage,
	},
	props: {
		app: {
			required: true,
			type: Object,
		},
	},

	methods: {
		launch() {
			if (isUuid(this.app.id)) {
				tracker("launch-custom-tile", {
					tile_id: this.app.id,
					tile_name: this.app.name,
				});
			} else {
				tracker("launch-app", {
					application_id: this.app.id,
					application_name: this.app.name,
				});
			}

			if (this.app.launch_url) {
				this.loadHyperlink();
			} else if (this.app.sso_active) {
				this.loadSingleSignOn();
			} else {
				this.loadSavedPassword();
			}
		},

		loadHyperlink() {
			window.open(this.app.launch_url);
		},

		loadSavedPassword() {
			let routeData = this.$router.resolve({ name: "saved-password", params: { company: this.app.slug } });
			window.open(routeData.href, "_blank");
		},

		loadSingleSignOn() {
			let routeData = this.$router.resolve({
				name: "authorize",
				query: {
					redirect_uri: this.app.redirect,
					client_id: this.app.client_id,
				},
			});
			window.open(routeData.href, "_blank");
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/student/Tile.vue